import appConfig from '../config';
import image1 from '../public/assets/images/host-slides/host1.webp';
import image2 from '../public/assets/images/host-slides/host2.webp';
import image3 from '../public/assets/images/host-slides/host3.webp';
import image4 from '../public/assets/images/host-slides/host4.webp';
import image5 from '../public/assets/images/host-slides/host5.webp';
import image6 from '../public/assets/images/host-slides/host6.webp';
import image7 from '../public/assets/images/host-slides/host7.webp';

export type HostSlideConfigType = {
	hostId: string;
	authorFullname: string;
	eventName: string;
};

export type HostSlideType = {
	id: string;
	image: { src: string; width: number; height: number };
	authorFullname: string;
	eventName: string;
};

export const hostImages = [image1, image2, image3, image4, image5, image6, image7];

export const HostSlidesMap: Record<string, HostSlideType> = {
	...(appConfig.MAIN_PAGE_HOST_SLIDER?.reduce(
		(acc, hostSlide, index) => ({
			...acc,
			[hostSlide.hostId]: {
				id: hostSlide.hostId,
				image: hostImages[index],
				authorFullname: hostSlide.authorFullname,
				eventName: hostSlide.eventName,
			},
		}),
		{}
	) || {}),
};
